import { clsx } from "clsx";
import { FieldValues, FieldErrors, UseFormRegister } from "react-hook-form";
import "./NicheInputField.scss";

interface INicheInputFieldProps {
  id: "name" | "description" | "rules";
  label: string;
  register: UseFormRegister<{ name: string; description: string; rules: string }>;
  errors: FieldErrors<FieldValues>;
  placeholder?: string;
  value?: string;
  type?: string;
  rows?: number;
  errorMessage: string;
  disabled?: boolean;
}

export const NicheInputField: React.FC<INicheInputFieldProps> = ({
  label,
  id,
  register,
  errors,
  errorMessage,
  value,
  type,
  ...props
}) => {
  const Element = !type ? "textarea" : "input";

  return (
    <div className={clsx("NicheInputField", errors[id] && "NicheInputField_WithError")}>
      <label className="NicheInputField-Label" htmlFor={id}>
        {label}
        <Element
          {...register(id, { required: true })}
          id={id}
          className="NicheInputField-Input"
          type={type}
          {...props}
        />
      </label>
      {errors[id] && <p>{errorMessage}</p>}
    </div>
  );
};
